<template>
	<div>
		<app-filter @setFilter="filter" />
		<sBox title="Grade de categorias">
			<div slot="tools">
				<aBtn
					action="private-save-categories"
					@click="$refs.modal.open()"
					text="Categoria"
					icon="plus"
					size="sm"
					type="success"
				/>
			</div>
			<div slot="body">
				<sTable
					ref="tab"
					actionRead="private-read-services"
					actionDelete="private-delete-services"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					block
					@edit="(data) => $refs.modal.open(data)"
				/>
			</div>
		</sBox>
		<modal ref="modal" @update="$refs.tab.updateTable()" :assets="assets" />
		<!-- $route.params.id -->
	</div>
</template>
<script>
	import WBS from 'js/http';
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';
	import appFilter from './filter.vue';

	import pad from 'js/pad';

	export default {
		name: 'AppCadastroCategorias',
		components: { sTable, sBox, aBtn, modal, appFilter },
		data() {
			return {
				labels: [
					{ data: 'cod', label: 'Cod' },
					{ data: ['servico', 'sigla'], label: 'Serviço', two: true },
					{ data: 'tarefas', label: 'Departamentos' },
					// {data: 'tarefas', label: 'Departamentos'},
					{ data: 'valor', label: 'Valor' },
				],
				functions: [
					{
						cod: 'cod',
						fx: (val) => {
							return pad(val, 5);
						},
					},
					{ cod: 'tarefas', fx: this.get_duration },
					{
						cod: 'valor',
						fx: (val) => {
							return `R$ ${parseFloat(val).toFixed(2)}`;
						},
					},
				],
				assets: {
					tarefas: [],
					departamentos: [],
					forms: [],
				},
			};
		},
		provide() {
			const assets = {};
			Object.defineProperty(assets, 'departamentos', {
				enumerable: true,
				get: () => this.assets.departamentos,
			});
			Object.defineProperty(assets, 'forms', {
				enumerable: true,
				get: () => this.assets.forms,
			});
			return {
				assets: assets,
			};
		},
		watch: {
			'$route.params.id': function (val) {
				this.filter();
				this.setHeader();
			},
		},
		methods: {
			get_duration(val) {
				if (typeof val == 'object') {
					let deptos = [];
					let xOut = [];
					val.forEach((tar) => {
						if (typeof tar.deptos == 'object') {
							tar.deptos.forEach((dep) => {
								if (
									deptos.findIndex(
										(old_dep) => old_dep == dep
									) === -1
								) {
									let xDep = this.assets.departamentos.find(
										(xDep) => xDep.cod == dep
									);
									if (xDep !== undefined)
										deptos.push(xDep.titulo);
								}
							});
						}
					});
					deptos.forEach((depto) => {
						xOut.push(
							`<span class='label label-primary'>${depto}</span>`
						);
						// console.log(depto)
					});
					return xOut.join(' ');
				} else {
					return [];
				}
			},
			filter(data = null) {
				// console.log(data)
				let filter = [];
				filter.push(`cat = '${this.$route.params.id}' `);
				if (data != null) {
					if (data.cod != '') filter.push(`cod = '${data.cod}' `);
					if (data.title != '')
						filter.push(
							`( servico like '%${data.title}%' or sigla like '%${data.title}%' )`
						);

					if (data.depto != '')
						filter.push(`cache_deptos like '%|${data.depto}|%'`);
					if (data.form != '')
						filter.push(`cache_forms like '%|${data.form}|%'`);
				}
				// console.log(filter.join(" and "))
				this.$refs.tab.setFilter(filter.join(' and '));
				this.$refs.tab.updateTable();
			},
			setHeader() {
				let trans = {
					sms: 'Serviços SMS',
					'off-shore': 'Serviços Off-Shore',
					internal: 'Serviços Internos',
					web: 'Serviços SST',
				};
				this.$emit('setHeader', [
					trans[this.$route.params.id],
					'Gerenciamento de Serviços',
				]);
			},
		},
		mounted() {
			this.setHeader();
			this.filter();
			WBS.send('protected-read-AssetsServices', (resp) => {
				// console.log(resp)
				this.assets = resp.data;
			});
			// console.log(this.$route.params.id)
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/services/index.vue